import { DashboardWidget } from "@/model/data/dashboard/DashboardWidget";
import { ApiGenericResponse } from "../../ApiGenericResponse";
import { API_PREFIX, API_VERSION, Command, HttpVerbType } from "../../Command";
import { FetchDashboardWidgetDataResData } from "./FetchDashboardWidgetDataResData";

export class FetchDashboardWidgetDataCommand extends Command {
    endPoint: string;
    httpVerb: HttpVerbType = "post";
    widget: DashboardWidget;

    constructor(widget: DashboardWidget) {
        super();
        this.endPoint = API_PREFIX + API_VERSION + `/dashboard/widgetData`;
        this.widget = widget;
    }

    public async execute(): Promise<FetchDashboardWidgetDataResData> {
        var res = await this.executeCommand(this.widget);
        return new FetchDashboardWidgetDataResData(res);
    }
}
